/**
 * Adapter so react-helmet-async works in both Vite SSR (CJS, no named exports)
 * and client build (ESM, no default export). Uses default or namespace.
 * Unwrap .default on each export so we never pass an object as element type.
 */
import * as ns from 'react-helmet-async-pkg'
const pkg = ns.default ?? ns
const unwrap = (m) => (m && typeof m === 'object' && m.default != null ? m.default : m)
export const HelmetProvider = unwrap(pkg.HelmetProvider)
export const Helmet = unwrap(pkg.Helmet)
